(function maytrixFitDesktopCustomizer() {
  'use strict';

  var desktop = window.matchMedia('(min-width: 1000px)');
  var root = document.documentElement;
  var body = document.body;
  var frame = 0;
  var headerObserver = null;
  var bodyObserver = null;

  function reset() {
    if (body) body.classList.remove('myx-desktop-customizer');
    root.classList.remove('myx-desktop-customizer-root');
    root.style.removeProperty('--myx-desktop-customizer-height');
  }

  function sync() {
    frame = 0;
    body = document.body;
    var builder = document.getElementById('product-builder');
    var layout = builder && builder.querySelector('.cpb-layout');

    if (!desktop.matches || !body || !layout || body.classList.contains('myx-review-open')) {
      reset();
      return;
    }

    root.classList.add('myx-desktop-customizer-root');
    body.classList.add('myx-desktop-customizer');

    window.requestAnimationFrame(function () {
      var currentLayout = document.querySelector('#product-builder .cpb-layout');
      if (!currentLayout || !desktop.matches || !document.body || document.body.classList.contains('myx-review-open')) {
        reset();
        return;
      }

      var documentTop = Math.max(0, currentLayout.getBoundingClientRect().top + window.scrollY);
      var available = Math.max(420, Math.floor(window.innerHeight - documentTop));
      root.style.setProperty('--myx-desktop-customizer-height', available + 'px');
    });
  }

  function requestSync() {
    if (!frame) frame = window.requestAnimationFrame(sync);
  }

  function observeHeader() {
    if (!window.ResizeObserver || headerObserver) return;
    var header = document.querySelector('.shopify-section-group-header-group') || document.querySelector('header');
    if (!header) return;
    headerObserver = new ResizeObserver(requestSync);
    headerObserver.observe(header);
  }

  function observeBody() {
    if (!window.MutationObserver || bodyObserver || !document.body) return;
    bodyObserver = new MutationObserver(requestSync);
    bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  function boot() {
    body = document.body;
    observeHeader();
    observeBody();
    requestSync();

    var attempts = 0;
    var timer = window.setInterval(function () {
      observeHeader();
      requestSync();
      if (document.querySelector('#product-builder .cpb-layout') || attempts++ > 60) {
        window.clearInterval(timer);
        window.setTimeout(requestSync, 100);
        window.setTimeout(requestSync, 500);
      }
    }, 200);
  }

  window.addEventListener('resize', requestSync);
  window.addEventListener('orientationchange', requestSync);
  window.addEventListener('pageshow', requestSync);
  document.addEventListener('CPB_ON_PRODUCT_MOUNTED', requestSync);
  document.addEventListener('CPB_ON_OPTIONS_UPDATE', requestSync);
  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', requestSync);
  document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', requestSync);
  if (desktop.addEventListener) desktop.addEventListener('change', requestSync);
  else desktop.addListener(requestSync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
